import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { PersonalInfo } from '../components/profil/PersonalInfo';
import { AddressList } from '../components/profil/AddressList';
import { AccountNav, type PanelId } from '../components/profil/AccountNav';
import { AtnaHelp } from '../components/profil/AtnaHelp';
import { AccountManagement } from '../components/profil/AccountManagement';
import { AccountPanel } from '../components/profil/AccountPanel';
export function MonProfil() {
  const [panel, setPanel] = useState<PanelId | null>(null);
  return <main id="profil" className="bg-white" data-id="element-2239" data-mp="ul5365mle6dm">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2240" data-mp="uismdvskm225">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2241" data-mp="pn3g79m1pmwv">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2242" data-mp="2wcrw4cq1obcq">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2243" data-mp="2rf9i47x675xv" />
          <span aria-current="page" data-id="element-2244" data-mp="1cfze943xvva2">Mon profil</span>
        </nav>

        <header className="mt-4" data-id="element-2245" data-mp="1hd7w13l6dxas">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2246" data-mp="1he96b5udafrg">Mon profil</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2247" data-mp="1mbj4pazqi1rf">
            Gérez vos informations personnelles, vos préférences et vos options de confidentialité.
          </p>
        </header>

        <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,360px)] lg:gap-10" data-id="element-2248" data-mp="1v4w7d4nlohqp">
          <div data-id="element-2249" data-mp="202e6627wlgkz">
            <PersonalInfo data-id="element-2250" data-mp="206bowmqkk64c" />
            <AddressList data-id="element-2251" data-mp="253lh2a5cevvv" />
            <div className="mt-6 flex justify-end" data-id="element-2252" data-mp="254dbhhn7enkk">
              <button type="button" className="rounded-full bg-ville-navy px-7 py-3 text-base font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2253" data-mp="2a2eszy4zeetx">
                Sauvegarder
              </button>
            </div>
          </div>

          <div data-id="element-2254" data-mp="2ouy1fph5gzw">
            <AccountNav onOpen={setPanel} data-id="element-2255" data-mp="2pehx1yoqfgk" />
            <AtnaHelp data-id="element-2256" data-mp="2qpk4xchff5k" />
          </div>
        </div>

        <AccountManagement data-id="element-2257" data-mp="hm5hbb8czr66" />
      </div>

      <AccountPanel panel={panel} onClose={() => setPanel(null)} data-id="element-2258" data-mp="hn6vhoko8ts4" />
    </main>;
}